import Vue from 'vue';
import { API_HOST } from '../constants';

/* eslint-disable camelcase */

export default {
  get(params = {}) {
    return Vue.axios.get(`${API_HOST}/information`, { params });
  },
  getId(id) {
    return Vue.axios.get(`${API_HOST}/information/${id}`);
  },
};



// WEBPACK FOOTER //
// ./src/api/information.js